import { Formik } from 'formik';
import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useManualNetworkPointByUuid } from 'src/apis/monolith/use-network-point-by-uuid';
import { FormContainer } from 'src/components/form/form-container';
import { NetworkPointSelect } from 'src/components/form/select/network-point-select/network-point-select';

type FormValues = {
  globalNetworkPoint?: { label: string; value: string };
};

type Props = {
  initialOpen?: boolean; // Just needed for storybook
  initialSearch?: string; // Just needed for storybook
};

export const NetworkPointSearchNew: FC<Props> = ({
  initialOpen,
  initialSearch,
}) => {
  const { push } = useHistory();
  const oldNetworkPoint = useManualNetworkPointByUuid();

  useEffect(() => {
    if (!oldNetworkPoint.response) return;
    push(
      `/platform/#/network-point/details/${oldNetworkPoint.response.data.id}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oldNetworkPoint.response]);

  return (
    <Formik<FormValues>
      initialValues={{ globalNetworkPoint: undefined }}
      onSubmit={(values, helpers) => {
        if (values.globalNetworkPoint?.value) {
          oldNetworkPoint.execute(values.globalNetworkPoint.value);
          helpers.setFieldValue('globalNetworkPoint', undefined);
        }
      }}
    >
      {({ submitForm }) => (
        <FormContainer mode="search">
          <NetworkPointSelect
            name="globalNetworkPoint"
            label="Network Point"
            placeholder="Find a Network Point"
            hideLabel
            onChange={submitForm}
            pending={oldNetworkPoint.pending}
            initialOpen={initialOpen}
            initialSearch={initialSearch}
          />
        </FormContainer>
      )}
    </Formik>
  );
};
